import { useMemo } from 'react';

import { VisitHistoryEdm, VisitHistoryEdmQuery, VisitHistoryEdmType } from '@dreryk/egabinet-visit-frontend-api';

import {
   AlignItems,
   createDynamicColumnsWidth,
   JustifyContent,
   Padding,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';
import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';

import { visitHistoryTranslationKeys } from '../../translations';

import { OptionsCell } from './cells/OptionsCell';

export const useElectronicDocumentsDataConfiguration = (
   visitId: number
): LazyLoadedDataConfigurationByCqrsQuery<VisitHistoryEdm> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<VisitHistoryEdm>(() => {
      const query = new VisitHistoryEdmQuery();
      query.visitId = visitId;
      return query;
   });
};

export const useElectronicDocumentsColumnsConfiguration =
   // eslint-disable-next-line max-lines-per-function
   (): TableColumnConfiguration<VisitHistoryEdm>[] => {
      // eslint-disable-next-line max-lines-per-function
      return useMemo<TableColumnConfiguration<VisitHistoryEdm>[]>(() => {
         const columnsWidth = createDynamicColumnsWidth({
            type: '33.3%',
            diagnosis: '33.3%',
            procedure: '33.4%',
            options: '24px',
         });

         return [
            {
               name: 'documentType',
               label: visitHistoryTranslationKeys.electronicDocumentsTable.type,
               width: columnsWidth.type,
               accessor: 'type',
               sortingDisabled: true,
               justifyContent: JustifyContent.START,
               alignItems: AlignItems.CENTER,
               renderer: ({ value: type }: ValueRendererProps<VisitHistoryEdm, VisitHistoryEdmType>): JSX.Element => {
                  return (
                     <Translate>{visitHistoryTranslationKeys.electronicDocumentsTable.documentTypeMap[type]}</Translate>
                  );
               },
            },
            {
               name: 'diagnosis',
               label: visitHistoryTranslationKeys.electronicDocumentsTable.diagnosis,
               width: columnsWidth.diagnosis,
               accessor: 'diagnosis',
               sortingDisabled: true,
               justifyContent: JustifyContent.START,
               alignItems: AlignItems.CENTER,
               renderer: (bean): JSX.Element | null => {
                  return bean.value ? <>{bean.value.getCode().asString()}</> : null;
               },
            },
            {
               name: 'procedure',
               label: visitHistoryTranslationKeys.electronicDocumentsTable.procedure,
               width: columnsWidth.procedure,
               accessor: 'procedure',
               sortingDisabled: true,
               justifyContent: JustifyContent.START,
               alignItems: AlignItems.CENTER,
               renderer: (bean): JSX.Element | null => {
                  return bean.value ? <>{bean.value.getCode().asString()}</> : null;
               },
            },
            {
               name: 'options',
               width: columnsWidth.options,
               accessor: 'medicalDocumetUrl',
               sortingDisabled: true,
               padding: Padding.NONE,
               renderer: (bean): JSX.Element | null => {
                  return bean.value ? <OptionsCell documentUrl={bean.value} /> : null;
               },
            },
         ];
      }, []);
   };
